export default __webpack_public_path__ + "static/media/button_goback_zh_tw.a4ad23ff.svg";